import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { EmployeeCell } from "components/cell/employee/cell";
import { DateCell } from "@/components/date/cell";
import HeaderPortal from "components/portal/header-portal";
import { getUserFields } from "components/user/config";
import { StatusCell } from "@/components/status/cell";
import OpeningsFilters from "./filters";
import { SkillCell } from "./components/_cell";
import ExpertiseDisplay from "./components/expertise-display";
import { LinkCell } from "@/components/link/cell";
import { PermissionGate } from "permissions/components/gate";

export default function Openings() {

    const fields = [
        "id",
        "title",
        getUserFields("sales_coordinator"),
        "skills.skill.id",
        "skills.skill.name",
        "expertise",
        "opportunity_link",
        "status",
        "date_created",
    ];

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
        {
            id: "sales_coordinator",
            header: "SC",
            accessorKey: "sales_coordinator",
            cell: EmployeeCell,
        },
        {
            id: "expertise",
            header: "Expertise",
            accessorKey: "expertise",
            cell: ExpertiseDisplay,
        },
        {
            id: "skills",
            header: "Skills",
            accessorKey: "skills",
            cell: SkillCell,
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_created",
            header: "Created",
            accessorKey: "date_created",
            cell: DateCell,
            sortable: true,
        },
        {
            id: "opportunity_link",
            header: "Link",
            accessorKey: "opportunity_link",
            cell: LinkCell,
        },
    ];

    const defaultFilters = {
        status: { _nin: [ "inactive" , "archived" ] },
    };

    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionGate rule={"create:*"} collection="openings">
                    <CreateItemButton href={"/apps/openings/+"}>Opening</CreateItemButton>
                </PermissionGate>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Openings"
                    endPoint="openings"
                    storageKey="openings-list"
                    perPage={10}
                    columns={columns}
                    filters={defaultFilters}
                    meta={{
                        fields,
                    }}
                    href={(item) => `/apps/openings/${item.id}`}
                    renderFilters={OpeningsFilters}
                />
            </div>
        </div>
    );
}
